export default __webpack_public_path__ + "static/media/soluciones__1.9039a617.jpg";